import { requestApi } from 'serviceWorker/api/requestApi';
import type { OrganizationLogoAddress } from 'shared/domain/organization/organizationContract';

/** A signed URL to download the organization's logo. */
export async function getLogoSignedUrl({ organizationId, logoId }: OrganizationLogoAddress): Promise<string> {
  const { signedRequest } = await requestApi<{ signedRequest?: unknown }>({
    method: 'GET',
    path: `client/${organizationId}/logo/${logoId}/download`,
  });
  if (typeof signedRequest !== 'string') {
    throw new Error(`No signed URL for logo ${logoId} of organization ${organizationId}`);
  }
  return signedRequest;
}
